import validatePresence from './validatePresence';

const validateCurrency = (value: unknown): string | boolean => validatePresence(value, ['amount']);

export default validateCurrency;